import { t } from 'i18next';

import { initialPeriodsTableRow, IPeriodsTableRow } from 'components/BusinessToolForm/constants/periods';
import { getFormTableInitialValues2 } from 'components/BusinessToolForm/utils/helpers';

export const LOAN_REPAYMENT_SCHEDULE_NAMES = {
  CURRENCY: 'currency',
  VARIANTS: 'variants',
  TABLE: 'table',
} as const;

const loanRepaymentScheduleVariants = [
  'Repayment of loan',
  'Interest payment',
];

export interface ILoanRepaymentScheduleFormValuesType {
  [LOAN_REPAYMENT_SCHEDULE_NAMES.VARIANTS]: string[];
  [LOAN_REPAYMENT_SCHEDULE_NAMES.TABLE]: IPeriodsTableRow[];
}

export const loanRepaymentScheduleInitialValues = {
  [LOAN_REPAYMENT_SCHEDULE_NAMES.VARIANTS]: loanRepaymentScheduleVariants,
  [LOAN_REPAYMENT_SCHEDULE_NAMES.TABLE]: getFormTableInitialValues2(
    loanRepaymentScheduleVariants.length,
    initialPeriodsTableRow,
  ),
};
